// Copied from transition-web/src/libs/useQueryParams.ts
// TODO: Adapt for new routing system

import { useMemo } from 'react'

export default function useQueryParams<T = Record<string, string>>(): T {
  return useMemo(() => {
    const params = new URLSearchParams(window.location.search)
    const result = {} as T

    for (const [key, value] of params.entries()) {
      // Dynamic object property assignment - cast through Record for URLSearchParams parsing
      ;(result as Record<string, string>)[key] = value
    }

    return result
  }, [])
}
